import _ from 'lodash';
import { pipe } from 'lodash/fp';
import { IClientConfig } from 'src/client-config/config';
import { addKeyInEach } from 'src/common/helpers/declarative';
import { ISelection } from 'src/constants/interfaces/bet';
import { getPrice } from '../priceCalculation';

const getPossibleWinFromStake = (stake: number, price: number, onlyProfit = false) => {
    const odd = onlyProfit ? price - 1 : price;
    return stake * odd;
};

const getSingleSelectionPossibleWin = ({ singleStake, event }: ISelection) => {
    if (!singleStake || !+singleStake) return 0;
    return getPossibleWinFromStake(+singleStake, event.price);
};

const addSinglePossibleWinInEachSelection = _.partial(addKeyInEach, 'singlePossibleWin', getSingleSelectionPossibleWin);
const sumAllSinglePossibleWins = _.partialRight(_.sumBy, 'singlePossibleWin');

const getSingleListPossibleWin = pipe(
    addSinglePossibleWinInEachSelection,
    sumAllSinglePossibleWins,
);

export const getSinglePossibleWin = (config: IClientConfig, stake: number, selections: ISelection[]) => {
    if (config.enableSingles) return getSingleListPossibleWin(selections);
    return getPossibleWinFromStake(stake, getPrice(selections[0]));
};